import {} from '@apollo/client';
import {} from '@graphql-typed-document-node/core';
import { readable } from 'svelte/store';
/**
 * Compatibility layer emitted by the local codegen plugin on top of
 * `@graphql-codegen/typed-document-node` output. Preserves the call-site
 * ergonomics that `graphql-codegen-svelte-apollo` used to produce so that
 * consumers can migrate off the wrapper gradually without a big-bang refactor.
 *
 * Matches the historical shapes:
 *   - Query (watch):   `SomeQuery(options) => Readable<ApolloQueryResult & { query }>`
 *   - Query (async):   `AsyncSomeQuery(options) => Promise<ApolloQueryResult>`
 *   - Mutation:        `SomeMutation(options) => Promise<FetchResult>`
 *   - Subscription:    `SomeSubscription(options) => Observable<FetchResult>`
 */
export function createCompatHelpers(client) {
    const makeQueryStore = (doc) => (options) => {
        const q = client.watchQuery({ query: doc, ...options });
        return readable({
            data: {},
            loading: true,
            error: undefined,
            networkStatus: 1,
            query: q
        }, (set) => {
            const sub = q.subscribe((v) => set({ ...v, query: q }));
            return () => sub.unsubscribe();
        });
    };
    const makeAsyncQuery = (doc) => (options) => client.query({ query: doc, ...options });
    const makeMutation = (doc) => (options) => client.mutate({ mutation: doc, ...options });
    const makeSubscription = (doc) => (options) => client.subscribe({ query: doc, ...options });
    return { makeQueryStore, makeAsyncQuery, makeMutation, makeSubscription };
}
